if (!customElements.get('lookbook-icon')) {
  customElements.define(
    'lookbook-icon',
    class LookbookIcon extends HTMLElement {
      constructor() {
        super();

        this.selectors = {
          cardContainer: '.lookbook-card',
          cardProduct: '.lookbook-card__product',
        };

        this.cardContainer = this.closest(this.selectors.cardContainer);
        this.cardProduct = this.querySelector(this.selectors.cardProduct);

        this._onInit = this.init.bind(this);
        this._onClick = this._onClick.bind(this);
        this._onDocClick = this._onDocClick.bind(this);

        this.init();
      }

      connectedCallback() {
        this.addEventListener('mouseover', this._onInit);
        this.addEventListener('click', this._onClick);
        document.addEventListener('click', this._onDocClick);
      }

      disconnectedCallback() {
        this.removeEventListener('mouseover', this._onInit);
        this.removeEventListener('click', this._onClick);
        document.removeEventListener('click', this._onDocClick);
      }

      _onClick(e) {
        // Agar product card ke andar click hua (link/button), normal kaam karne do
        if (e.target.closest(this.selectors.cardProduct)) return;

        // Doosri open hotspots band karo
        document.querySelectorAll('lookbook-icon.is-active').forEach((el) => {
          if (el !== this) el.classList.remove('is-active');
        });

        // Is hotspot ko toggle karo
        this.classList.toggle('is-active');

        // Position dobara calculate karo (kabhi orientation change ya scroll ke baad)
        this.init();

        // Document-level click handler ko fire na hone do
        e.stopPropagation();
      }

      _onDocClick(e) {
        // Agar hotspot ke bahar click hua aur ye open hai → band karo
        if (!this.contains(e.target) && this.classList.contains('is-active')) {
          this.classList.remove('is-active');
        }
      }

      init() {
        if (this.cardProduct) {
          this.cardContainerOffsetX = this.cardContainer.getBoundingClientRect().left;
          this.cardContainerOffsetY = this.cardContainer.getBoundingClientRect().top;

          this.offsetX = this.getBoundingClientRect().left - this.cardContainerOffsetX;
          this.offsetY = this.getBoundingClientRect().top - this.cardContainerOffsetY;

          this.cardProductWidth = this.cardProduct.clientWidth;
          this.cardProductHeight = this.cardProduct.clientHeight;
          this.cardContainerWidth = this.cardContainer.clientWidth;

          if (this.offsetX > this.cardProductWidth) {
            this.cardProduct.style.left = 'auto';
            if (this.cardContainerWidth - this.offsetY < 15) {
              this.cardProduct.style.right = 'calc(-100% + 2rem)';
            } else {
              this.cardProduct.style.right = '-100%';
            }
          } else {
            this.cardProduct.style.right = 'auto';
            if (this.cardContainerWidth - this.offsetX > this.cardProductWidth) {
              if (this.offsetX < 15) {
                this.cardProduct.style.left = 'calc(-100% + 2rem)';
              } else {
                this.cardProduct.style.left = '-100%';
              }
            } else {
              this.cardProduct.style.left = this.cardContainerWidth - this.cardProductWidth - this.offsetX + 'px';
            }
          }

          if (this.offsetY > this.cardProductHeight) {
            this.cardProduct.style.top = 'auto';
            this.cardProduct.style.bottom = '100%';
          } else {
            this.cardProduct.style.bottom = 'auto';
            this.cardProduct.style.top = '100%';
          }
        }
      }
    }
  );
}